import backups from "./backups.component";
import backupsUrls from "./backups.urls";
import BackupsTransforms from "./backups.transforms";

const backupsModule = angular
  .module("app.components.backups", [])
  .component("backupsPage", backups)
  .service("BackupsTransforms", BackupsTransforms)
  .config(backupsUrls);

export default backupsModule;



// WEBPACK FOOTER //
// ./src/pages/backups/backups.module.js